import { render } from "./pc-colour-swatches.vue?vue&type=template&id=f8795d30"
import script from "./pc-colour-swatches.vue?vue&type=script&lang=js"
export * from "./pc-colour-swatches.vue?vue&type=script&lang=js"

import "./pc-colour-swatches.vue?vue&type=style&index=0&id=f8795d30&lang=scss"

import exportComponent from "/Users/andrewamistad/Sites/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__